import React, { useEffect, useState } from "react";
import DetailLayout from "../../components/DetailLayout";
import QuestionTopicsHeader from "./components/QuestionTopicsHeader";
import style from "./index.module.scss";
import ExerciseTopicsButtons from "./components/ExerciseTopicsButtons";
import TopicList from "./components/TopicList";
import { RouteComponentProps } from "react-router-dom";
import TopicEmpty from "./components/TopicEmpty";
import AddTopicModal from "./components/AddTopicModal";
import useModalHandler from "utils/v3/useModalHandler";
import useRequest from "utils/useRequest";
import { getQuestionList, saveQuestion } from "service/question";
import { Button, message, Spin } from "antd";
import TopicContent from "./components/TopicContent";
import { useAtomValue } from "jotai";
import { typeIdsAtom } from "../../../../service/stores/Question/QuestionTypes";
import QuestionCloneModal from "./components/QuestionCloneModal";

interface ExerciseTopicsProps {
    id: string;
}

export default function QuestionTopics({
    match
}: RouteComponentProps<ExerciseTopicsProps>) {
    const questionnaireId = match.params.id;
    const addModal = useModalHandler();
    const questionCloneModal = useModalHandler({
        component: QuestionCloneModal
    });
    const [checked, setChecked] = useState<number>(); //当前选中第一项

    const [dataList, { loading }, refreshData] = useRequest(
        () => getQuestionList(questionnaireId),
        {},
        [questionnaireId]
    );
    const currentData = dataList?.find(item => item.id === checked);
    const currentIndex =
        dataList && dataList.length !== 0
            ? dataList.findIndex(item => item.id === checked)
            : 0;

    useEffect(() => {
        if (dataList && dataList.length !== 0) {
            if (!checked || !currentData) {
                setChecked(dataList[0].id);
            }
        }
    }, [dataList]);

    async function onAddTopic(data: any) {
        await saveQuestion({ ...data, paperId: questionnaireId });
        message.success("添加成功!");
        refreshData();
    }

    const allTypeIds = useAtomValue(typeIdsAtom);

    function copySuccess() {
        refreshData();
        questionCloneModal.close();
    }

    function cloneQuestion() {
        questionCloneModal.open({
            questionnaireId,
            onOk: copySuccess
        });
    }

    return (
        <DetailLayout breadcrumb="问卷详情">
            <Spin spinning={loading}>
                <QuestionTopicsHeader
                    questionnaireId={questionnaireId}
                    visible={!!(dataList && dataList.length > 0)}
                    reload={refreshData}
                />
                {allTypeIds.length > 0 && (
                    <ExerciseTopicsButtons
                        data={dataList || []}
                        onAdd={addModal.open}
                        onCloneExercise={cloneQuestion}
                    />
                )}

                <div className={style.main}>
                    <div className={style.left}>
                        {dataList && dataList?.length !== 0 && (
                            <TopicList
                                data={dataList}
                                checked={checked}
                                questionnaireId={questionnaireId}
                                onChange={(val: number) => setChecked(val)}
                                handleOrder={refreshData}
                            />
                        )}
                    </div>

                    {dataList && dataList.length !== 0 && (
                        <div className={style.right}>
                            {currentData && (
                                <TopicContent
                                    currentData={currentData}
                                    questionnaireId={questionnaireId}
                                    refreshData={refreshData}
                                />
                            )}

                            <div className={style.footer}>
                                {currentIndex !== 0 && (
                                    <Button
                                        type="link"
                                        className={style.prev}
                                        onClick={() =>
                                            setChecked(
                                                dataList[currentIndex - 1].id
                                            )
                                        }>
                                        上一题
                                    </Button>
                                )}
                                {currentIndex !== dataList.length - 1 && (
                                    <Button
                                        type="link"
                                        className={style.next}
                                        onClick={() =>
                                            setChecked(
                                                dataList[currentIndex + 1].id
                                            )
                                        }>
                                        下一题
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}

                    {(!dataList || dataList.length === 0) && (
                        <TopicEmpty onAdd={addModal.open} />
                    )}
                </div>
            </Spin>

            {addModal.render(
                <AddTopicModal
                    title="添加题目"
                    onOk={onAddTopic}
                    types={allTypeIds}
                />
            )}
            {questionCloneModal.render()}
        </DetailLayout>
    );
}
